import { Card } from "primereact/card";
import { InputSwitch } from "primereact/inputswitch";
import { Skeleton } from "primereact/skeleton";
import { useBreadcrumb } from "sj-ui-toolkit/src/atlas/hooks/useBreadcrumbs";
import { AdminAppRoutes } from "sj-ui-toolkit/src/constants/routes";
import { useAspenFeatures } from "@/hooks/useAspenFeatures";

export default function AspenSettings() {
  useBreadcrumb({
    label: "Aspen Settings",
    route: AdminAppRoutes.routes.aspen.routes.settings.route,
    display: "none",
    resetTrail: true,
  });

  const { features, isLoading, viewOnly, enableAspenGlobally, toggleFeature, toggleGlobal } =
    useAspenFeatures();

  if (isLoading) return <Skeleton width="100%" height="20rem" />;

  return (
    <>
      <h1 className="mb-4">Aspen Settings</h1>

      <Card pt={{ content: { className: "p-0" } }} className="mb-4">
        <p>
          Security Journey takes the security of your data seriously. This page lets you manage all
          of Security Journey&apos;s AI functionality in one place, so you can be sure your data is
          being handled according to your company policies. You can disable our Aspen AI product
          entirely or toggle individual features on or off to control which capabilities are
          available to your team.
        </p>
        <div className="mt-4 flex items-center justify-between gap-4">
          <div>
            <strong>Aspen enabled globally</strong>
            <p className="body-sm text-secondary">This setting also controls Aspen chat.</p>
          </div>
          <InputSwitch
            checked={enableAspenGlobally}
            onChange={e => void toggleGlobal(e.value)}
            disabled={viewOnly}
          />
        </div>
      </Card>

      <Card title="Features" pt={{ content: { className: "p-0" } }} className="mb-4">
        <div className="flex flex-col gap-4 p-4">
          <div className="flex items-center justify-between">
            <div>
              <strong>Aspen Adapt</strong>
              <p className="body-sm text-secondary">
                CWE-based training recommendations from developer activity
              </p>
            </div>
            <InputSwitch
              checked={features.adapt}
              onChange={e => void toggleFeature("adapt", e.value)}
              disabled={viewOnly || !enableAspenGlobally}
            />
          </div>
          <div className="flex items-center justify-between">
            <div>
              <strong>Aspen Assist</strong>
              <p className="body-sm text-secondary">AI-powered hints in sandbox lessons</p>
            </div>
            <InputSwitch
              checked={features.assist}
              onChange={e => void toggleFeature("assist", e.value)}
              disabled={viewOnly || !enableAspenGlobally}
            />
          </div>
          <div className="flex items-center justify-between">
            <div>
              <strong>Aspen Guardian</strong>
              <p className="body-sm text-secondary">
                Automated AI instruction file updates from vulnerability scans
              </p>
            </div>
            <InputSwitch
              checked={features.guardian}
              onChange={e => void toggleFeature("guardian", e.value)}
              disabled={viewOnly || !enableAspenGlobally}
            />
          </div>
        </div>
      </Card>
    </>
  );
}
